export default "__VITE_ASSET__SsWnxPjy__"